/**
 * Created by vsuthar on 4/4/20
 * Project: App Portal ©Palo Alto Networks
 */
const setAppBarPropsReducer = (state = { appBarProps: { isVertical: false } }, action) => {
  switch (action.type) {

    case 'SET_APP_BAR_PROPS':
      return { ...state, appBarProps: action.appBarProps }// ensure number
    default:
      return state
  }
}

export default setAppBarPropsReducer
